import React from "react";
import { Grid, InputAdornment, TextField } from "@material-ui/core";
import { FunctionField, NumberInput, TextInput } from "react-admin";

import { ShipmentLineItemStatus } from "../../../../utils/constants";
import { exceptionRenderer, trimDecimal } from "../../../../utils/utils";
import { getQuantityToPickLabel } from "../OutboundUtils";
import {
  calculatePickListRowQuantityState,
  getNestedValue,
  validateQuantity,
} from "./PickListItemUtils";

const ExceptionRenderer = ({ record, getSource }) => {
  const barcodeExceptionSource = getSource("barcodeException");
  const barcodeExceptionNoteSource = getSource("barcodeExceptionNote");
  const hasExceptionSource = getSource("hasException");

  const barcodeException = getNestedValue(record, barcodeExceptionSource);
  const barcodeExceptionNote = getNestedValue(
    record,
    barcodeExceptionNoteSource,
  );
  const hasException = getNestedValue(record, hasExceptionSource);

  const exceptions = {
    barcodeException,
    barcodeExceptionNote,
    hasException,
  };

  return (
    <FunctionField
      source={getSource("hasException")}
      render={() => exceptionRenderer(exceptions, "top")}
    />
  );
};

export const PickListInventoryItem = ({
  record,
  getSource,
  formData,
  scopedFormData,
  handleQuantityChange,
}) => {
  const rowQuantityState = calculatePickListRowQuantityState(
    record,
    formData,
    scopedFormData,
  );

  return (
    <Grid container direction="row" spacing={1}>
      <Grid item xs={3}>
        <TextInput
          source={getSource("inventoryItem.locationFullName")}
          label="Location"
          variant="outlined"
          fullWidth
          disabled
          helperText={false}
        />
      </Grid>
      <Grid item xs={2}>
        <NumberInput
          source={getSource("inventoryItem.quantityOnHand")}
          label="Qty On Hand"
          variant="outlined"
          fullWidth
          disabled
          helperText={false}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{`${
                formData.inventory?.inventoryUOM || ""
              }`}</InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          label="Qty Committed"
          variant="outlined"
          margin="dense"
          fullWidth
          disabled
          helperText={false}
          value={trimDecimal(rowQuantityState.quantityCommitted, 3)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{`${
                formData.inventory?.inventoryUOM || ""
              }`}</InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          label="Qty Available"
          variant="outlined"
          margin="dense"
          fullWidth
          disabled
          helperText={false}
          value={trimDecimal(rowQuantityState.quantityAvailable, 3)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{`${
                formData.inventory?.inventoryUOM || ""
              }`}</InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <NumberInput
          source={getSource("quantityToPick")}
          label={getQuantityToPickLabel(record)}
          variant="outlined"
          min={0}
          max={rowQuantityState.maxQuantityToPick}
          onChange={handleQuantityChange}
          validate={validateQuantity(
            0,
            rowQuantityState.maxQuantityToPick,
          )}
          disabled={
            record.status === ShipmentLineItemStatus.LOADED ||
            record.status === ShipmentLineItemStatus.VERIFIED ||
            record.status === ShipmentLineItemStatus.SHIPPED
          }
          helperText={false}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{`${
                formData.inventory?.inventoryUOM || ""
              }`}</InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item align="center" xs={1}>
        <ExceptionRenderer record={record} getSource={getSource} />
      </Grid>
    </Grid>
  );
};
